import { createAgent } from "../../../store/appearance/actions";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getSocket, initializeSocket } from "../../../helpers/socket";
import { toast } from "react-toastify";
import { createPortal } from "react-dom";
import CreateAiModelPop from "../../../components/Modals/CreatingModelPopup";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";

const Step4 = ({
  step,
  setStep,
  errors,
  setErrors,
  formData,
  handleObjectArrayChange,
  addToArray,
  removeFromArray,
}) => {
  const dispatch = useDispatch();
  const socket = getSocket();
  const navigate = useNavigate();
  const [createAi, setCreateAi] = useState(false);

  const { user } = useSelector((state) => state.Auth);
  const userId = user?._id || user?.user?._id;
  useEffect(() => {
    if (!socket && userId) {
      initializeSocket(userId);
    }
  }, [userId, socket]);
  // const handleSubmit = () => {
  //   console.log("Form submitted: line19", formData);
  //   const stepErrors = validateStep4(formData);
  //   if (Object.keys(stepErrors).length === 0) {
  //     console.log("Form submitted:", formData);
  //     setCreateAi(true);
  //     const callBack = (err, responce) => {
  //       if (err) {
  //         toast.error(err);
  //         setCreateAi(false);
  //       } else {
  //         console.log(responce, "teststs");
  //       }
  //     };
  //     dispatch(
  //       createAgent({
  //         data: formData,
  //         callBack: callBack,
  //       })
  //     );
  //   }
  // };

  const handleSubmit = () => {
    console.log("Form submitted: line19", formData);
    const stepErrors = validateStep4(formData);

    if (Object.keys(stepErrors).length === 0) {
      console.log("Form submitted:", formData);
      setCreateAi(true);

      // Build payload with cleanup
      const payload = { ...formData };

      // If voiceId exists, drop voiceUrl
      if (payload.voiceId) {
        delete payload.voiceUrl;
      }

      // If voiceId is empty string, remove it
      if (payload.voiceId === "") {
        delete payload.voiceId;
      }

      const callBack = (err, responce) => {
        if (err) {
          toast.error(err);
          setCreateAi(false);
        } else {
          console.log(responce, "teststs");
        }
      };

      dispatch(
        createAgent({
          data: payload,
          callBack: callBack,
        })
      );
    }
  };

  useEffect(() => {
    if (!socket) return;
    let errorStatus = ["error", "failed"];
    socket.on("agent_Notification", (data) => {
      console.log("Received Ai notification:", data);
      if (data.status == "success" && data.type == "agent-create") {
        console.log("stage1");
        setCreateAi(false);
        navigate(`/public-character`);
      } else if (
        errorStatus.includes(data.status) &&
        data.type == "agent-create"
      ) {
        toast.error("Failed! Please try again!");
        setCreateAi(false);
      }
    });
    return () => {
      socket.off("agent_Notification");
    };
  }, [socket]);

  const validateStep4 = (data) => {
    const newErrors = {};

    if (data.importantMemories.length === 0) {
      newErrors.importantMemories =
        "At least one Important Memories is required";
    } else {
      data.importantMemories.forEach((memory, index) => {
        if (!memory["Year/age"]) {
          newErrors[`importantMemories_${index}_Year/age`] =
            "Year/age is required";
        }

        if (!memory["Memory/event"]) {
          newErrors[`importantMemories_${index}_Memory/event`] =
            "Memory/Event is required";
        }

        if (!memory.Description) {
          newErrors[`importantMemories_${index}_Description`] =
            "Description is required";
        } else if (memory.Description.length < 10) {
          newErrors[`importantMemories_${index}_Description`] =
            "Description must be at least 10 characters";
        }
      });
    }
    setErrors(newErrors);
    return newErrors;
  };

  return (
    <>
      {createAi &&
        createPortal(
          <CreateAiModelPop createAi={createAi} setCreateAi={setCreateAi} />,
          document.body
        )}
      <form className="Wrpper d-flex flex-column  gap-4">
        <div>
          <div className="head">
            <h5 className="m-0 fw-sbold text-[24px]">
              Enter Important Memories with timeline
            </h5>
          </div>

          <div className="py-5 d-flex flex-column   gap-10 ">
            <div className="table-responsive d-md-block d-none">
              <table className="table">
                <thead>
                  <tr>
                    <th
                      className="px-3 py-2 border"
                      style={{ minWidth: "20%" }}
                    >
                      Age
                    </th>
                    <th
                      className="px-3 py-2 border"
                      style={{ minWidth: "20%" }}
                    >
                      {/* Memory/Event */} What memory do you want to save
                    </th>
                    <th
                      className="px-3 py-2 border"
                      style={{ minWidth: "20%" }}
                    >
                      {/* Description */} Tell the story behind this memory
                    </th>
                    <th className="px-3 py-2 border"></th>
                  </tr>
                </thead>
                <tbody>
                  {formData.importantMemories.map((item, index) => (
                    <tr
                      key={index}
                      className="transition duration-[400ms] rounded hover:bg-[#4F2AE6]/20"
                    >
                      <td className="px-3 py-2">
                        <input
                          type="text"
                          value={item["Year/age"]}
                          onChange={(e) =>
                            handleObjectArrayChange(
                              "importantMemories",
                              index,
                              "Year/age",
                              e.target.value
                            )
                          }
                          className="form-control"
                          placeholder="e.g. (Age 5)"
                        />

                        {errors[`importantMemories_${index}_Year/age`] && (
                          <p className="text-danger text-xs mt-1">
                            {errors[`importantMemories_${index}_Year/age`]}
                          </p>
                        )}
                      </td>
                      <td className="px-3 py-2">
                        <input
                          type="text"
                          value={item["Memory/event"]}
                          onChange={(e) =>
                            handleObjectArrayChange(
                              "importantMemories",
                              index,
                              "Memory/event",
                              e.target.value
                            )
                          }
                          className="form-control"
                          placeholder="e.g. First Day at School"
                        />
                        {errors[`importantMemories_${index}_Memory/event`] && (
                          <p className="text-danger text-xs mt-1">
                            {errors[`importantMemories_${index}_Memory/event`]}
                          </p>
                        )}
                      </td>
                      <td className="px-3 py-2">
                        <textarea
                          value={item.Description}
                          onChange={(e) =>
                            handleObjectArrayChange(
                              "importantMemories",
                              index,
                              "Description",
                              e.target.value
                            )
                          }
                          className="form-control h-auto"
                          placeholder="Describe the memory..."
                          rows="2"
                        />
                        {errors[`importantMemories_${index}_Description`] && (
                          <p className="text-danger text-xs mt-1">
                            {errors[`importantMemories_${index}_Description`]}
                          </p>
                        )}
                      </td>
                      <td className="px-3 py-2">
                        {formData.importantMemories.length > 1 && (
                          <Button
                            variant="transparent"
                            type="button"
                            onClick={() =>
                              removeFromArray("importantMemories", index)
                            }
                            className="fw-sbold"
                          >
                            {removeIcn}
                          </Button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="d-md-none flex flex-col gap-3">
              {formData.importantMemories.map((item, index) => (
                <div
                  className="p-4 row rounded-3 border border-dashed border-[#4a2ce5] w-100 bg-light"
                  key={index}
                >
                  <div className="col-lg-12 py-2">
                    <label
                      htmlFor=""
                      className="text-[13px] text-[#6F767E] font-sbold whitespace-nowrap "
                    >
                      Age
                    </label>
                    <input
                      type="number"
                      value={item["Year/age"]}
                      onChange={(e) =>
                        handleObjectArrayChange(
                          "importantMemories",
                          index,
                          "Year/age",
                          e.target.value
                        )
                      }
                      className="form-control"
                      placeholder="5"
                    />

                    {errors[`importantMemories_${index}_Year/age`] && (
                      <p className="text-red-500 text-[13px] mt-1">
                        {errors[`importantMemories_${index}_Year/age`]}
                      </p>
                    )}
                  </div>
                  <div className="col-lg-12 py-2">
                    <label
                      htmlFor=""
                      className="text-[13px] text-[#6F767E] font-sbold whitespace-nowrap "
                    >
                      {/* Memory/Event */}What memory do you want to save
                    </label>
                    <input
                      type="text"
                      value={item["Memory/event"]}
                      onChange={(e) =>
                        handleObjectArrayChange(
                          "importantMemories",
                          index,
                          "Memory/event",
                          e.target.value
                        )
                      }
                      className="
                      form-control"
                      placeholder="e.g. First Day at School"
                    />
                    {errors[`importantMemories_${index}_Memory/event`] && (
                      <p className="text-red-500 text-[13px] mt-1">
                        {errors[`importantMemories_${index}_Memory/event`]}
                      </p>
                    )}
                  </div>
                  <div className="col-lg-12 py-2">
                    <label
                      htmlFor=""
                      className="text-[13px] text-[#6F767E] font-sbold whitespace-nowrap "
                    >
                      {/* Description */}Tell the story behind this memory
                    </label>
                    <textarea
                      value={item.Description}
                      onChange={(e) =>
                        handleObjectArrayChange(
                          "importantMemories",
                          index,
                          "Description",
                          e.target.value
                        )
                      }
                      className="form-control"
                      placeholder="Describe the memory..."
                      rows="2"
                    />
                    <div className="text-[13px] text-gray-500 mt-1">
                      {item.Description ? item.Description.length : 0}{" "}
                      characters (minimum 10 required)
                    </div>
                    {errors[`importantMemories_${index}_Description`] && (
                      <p className="text-red-500 text-[13px] mt-1">
                        {errors[`importantMemories_${index}_Description`]}
                      </p>
                    )}
                  </div>
                  {formData.importantMemories.length > 1 && (
                    <div className="col-span-12 py-2">
                      <button
                        type="button"
                        onClick={() =>
                          removeFromArray("importantMemories", index)
                        }
                        className="bg-danger btn w-100 d-flex align-items-center justify-content-center rounded-3 h-[48px] gap-2 text-white"
                      >
                        {remoeIcn} Remove
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className="mt-5 d-flex align-items-center  justify-content-center">
              <button
                type="button"
                onClick={() =>
                  addToArray("importantMemories", {
                    "Year/age": "",
                    "Memory/event": "",
                    Description: "",
                  })
                }
                className="btn fw-sbold btn-secondary"
              >
                Add more +
              </button>
            </div>

            {errors.importantMemories && (
              <div className="text-danger text-sm text-center">
                {errors.importantMemories}
              </div>
            )}
          </div>
        </div>

        <div className="mt-10 mx-auto w-100" style={{ maxWidth: 300 }}>
          <button
            type="button"
            onClick={handleSubmit}
            className="d-flex align-items-center  justify-content-center  bg-blue-600 hover:bg-blue-700 text-white h-[40px] commonBtn btn rounded-pill  w-100 d-max-walign--[377px] mx-auto tra-contentnsition-colors w-100"
          >
            Submit
          </button>

          <button
            onClick={() => setStep(6)}
            className="d-flex align-items-center  justify-content-center  bg-blue-600 hover:bg-blue-700 text-white h-[40px] commonBtn btn rounded-pill
             max-w-[377px] mx-auto transition-colors gap -2 mt-3 w-100"
            type="button"
          >
            Back
          </button>
        </div>
      </form>
    </>
  );
};
export default Step4;

const removeIcn = (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.61601 16C2.17134 16 1.79101 15.8417 1.47501 15.525C1.15901 15.2083 1.00067 14.8287 1.00001 14.386V2H0.500007C0.358007 2 0.23934 1.952 0.144007 1.856C0.0486736 1.76 0.000673516 1.641 6.84931e-06 1.499C-0.000659817 1.357 0.0473402 1.23833 0.144007 1.143C0.240674 1.04767 0.35934 1 0.500007 1H4.00001C4.00001 0.793333 4.07667 0.613333 4.23001 0.46C4.38334 0.306666 4.56334 0.23 4.77001 0.23H9.23001C9.43667 0.23 9.61667 0.306666 9.77001 0.46C9.92334 0.613333 10 0.793333 10 1H13.5C13.642 1 13.7607 1.048 13.856 1.144C13.9513 1.24 13.9993 1.359 14 1.501C14.0007 1.643 13.9527 1.76167 13.856 1.857C13.7593 1.95233 13.6407 2 13.5 2H13V14.385C13 14.829 12.8417 15.209 12.525 15.525C12.2083 15.841 11.8283 15.9993 11.385 16H2.61601ZM5.30801 13C5.45001 13 5.56901 12.952 5.66501 12.856C5.76101 12.76 5.80867 12.6413 5.80801 12.5V4.5C5.80801 4.358 5.76001 4.23933 5.66401 4.144C5.56801 4.04867 5.44901 4.00067 5.30701 4C5.16501 3.99933 5.04634 4.04733 4.95101 4.144C4.85567 4.24067 4.80801 4.35933 4.80801 4.5V12.5C4.80801 12.642 4.85601 12.7607 4.95201 12.856C5.04801 12.952 5.16667 13 5.30801 13ZM8.69301 13C8.83501 13 8.95367 12.952 9.04901 12.856C9.14434 12.76 9.19201 12.6413 9.19201 12.5V4.5C9.19201 4.358 9.14401 4.23933 9.04801 4.144C8.95201 4.048 8.83334 4 8.69201 4C8.55001 4 8.43101 4.048 8.33501 4.144C8.23901 4.24 8.19134 4.35867 8.19201 4.5V12.5C8.19201 12.642 8.24001 12.7607 8.33601 12.856C8.43201 12.9513 8.55101 12.9993 8.69301 13Z"
      fill="#EE0000"
    />
  </svg>
);

const remoeIcn = (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.61601 16C2.17134 16 1.79101 15.8417 1.47501 15.525C1.15901 15.2083 1.00067 14.8287 1.00001 14.386V2H0.500007C0.358007 2 0.23934 1.952 0.144007 1.856C0.0486736 1.76 0.000673516 1.641 6.84931e-06 1.499C-0.000659817 1.357 0.0473402 1.23833 0.144007 1.143C0.240674 1.04767 0.35934 1 0.500007 1H4.00001C4.00001 0.793333 4.07667 0.613333 4.23001 0.46C4.38334 0.306666 4.56334 0.23 4.77001 0.23H9.23001C9.43667 0.23 9.61667 0.306666 9.77001 0.46C9.92334 0.613333 10 0.793333 10 1H13.5C13.642 1 13.7607 1.048 13.856 1.144C13.9513 1.24 13.9993 1.359 14 1.501C14.0007 1.643 13.9527 1.76167 13.856 1.857C13.7593 1.95233 13.6407 2 13.5 2H13V14.385C13 14.829 12.8417 15.209 12.525 15.525C12.2083 15.841 11.8283 15.9993 11.385 16H2.61601ZM5.30801 13C5.45001 13 5.56901 12.952 5.66501 12.856C5.76101 12.76 5.80867 12.6413 5.80801 12.5V4.5C5.80801 4.358 5.76001 4.23933 5.66401 4.144C5.56801 4.04867 5.44901 4.00067 5.30701 4C5.16501 3.99933 5.04634 4.04733 4.95101 4.144C4.85567 4.24067 4.80801 4.35933 4.80801 4.5V12.5C4.80801 12.642 4.85601 12.7607 4.95201 12.856C5.04801 12.952 5.16667 13 5.30801 13ZM8.69301 13C8.83501 13 8.95367 12.952 9.04901 12.856C9.14434 12.76 9.19201 12.6413 9.19201 12.5V4.5C9.19201 4.358 9.14401 4.23933 9.04801 4.144C8.95201 4.048 8.83334 4 8.69201 4C8.55001 4 8.43101 4.048 8.33501 4.144C8.23901 4.24 8.19134 4.35867 8.19201 4.5V12.5C8.19201 12.642 8.24001 12.7607 8.33601 12.856C8.43201 12.9513 8.55101 12.9993 8.69301 13Z"
      fill="currentColor"
    />
  </svg>
);
